import { render } from "./InsightOffcanvas.vue?vue&type=template&id=5a800fbf&scoped=true"
import script from "./InsightOffcanvas.vue?vue&type=script&lang=ts"
export * from "./InsightOffcanvas.vue?vue&type=script&lang=ts"

import "./InsightOffcanvas.vue?vue&type=style&index=0&id=5a800fbf&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5a800fbf"

export default script